import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Dropdown, Icon, Image, Text } from "@oneloop/jopijs";
import style from "./inmobiliarySections.module.scss";
import Trans from "@/components/shared/Trans";
import translations from "../../../FichaInfo.trans.json";
import { setEditedData } from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import {
  handleMailClick,
  handleWhatsappClick,
  validateImageEnabled,
} from "@/components/fichaInfo/utilities/helpers";
import { getCustomAgentBranch } from "@/store/slices/components/fichaInfo/services";

export default function AgentSection({ enabled }) {
  const dispatch = useDispatch();
  const state = useSelector((ste) => ste.FichaInfoSlice);
  const { showData, origin_data, isEdition, edited_data, agents, TOKKO_HOST } =
    state;
  const [imageEnable, setImageEnable] = useState();

  useEffect(() => {
    if (!edited_data.agent_user?.id)
      dispatch(
        setEditedData({
          key: "agent_user",
          value: origin_data.agent_user,
        })
      );
  }, []);

  validateImageEnabled(
    state[isEdition ? "edited_data" : showData].agent_user.photo
  )
    .then(() =>
      setImageEnable(
        state[isEdition ? "edited_data" : showData].agent_user.photo
      )
    )
    .catch(() => setImageEnable(false));

  const handleAgentSelect = (user) => {
    dispatch(
      setEditedData({
        key: "agent_user",
        value: user,
      })
    );
    dispatch(getCustomAgentBranch({ agentID: user.id, host: TOKKO_HOST }));
  };

  return (
    <Box
      className={`${style.agentContainer} ${isEdition ? style.isEdition : ""}`}
      data-enabled={enabled}
      data-testid="show_agent-card"
    >
      {imageEnable ? (
        <Image
          style={{ minWidth: "48px" }}
          borderRadius="50%"
          height="48px"
          src={imageEnable}
        />
      ) : (
        <Icon className={style.agentWithoutImage} icon="icon-contactos" />
      )}
      {isEdition ? (
        <Box __css={{ width: "100%", maxWidth: "236px" }}>
          <Text
            padding="4px 8px"
            variant="heading.5"
            fontWeight="bold"
            color="var(--neutralGray1)"
            className={style.colorNeutralGray1}
          >
            {Trans(translations, "Agent")}
          </Text>
          <Dropdown
            onClick={(e) => {
              e.stopPropagation();
            }}
            height="auto"
          >
            <Dropdown.Button
              variant="dropdownOutlined"
              text={edited_data.agent_user.name}
              filled={edited_data.agent_user.name}
            />
            <Dropdown.Items
              clickClose={true}
              style={{ zIndex: "100", maxWidth: "100%" }}
            >
              {agents.map((user) => (
                <Dropdown.Default
                  key={user.name}
                  onClick={() => handleAgentSelect(user)}
                >
                  {user.name}
                </Dropdown.Default>
              ))}
            </Dropdown.Items>
          </Dropdown>
        </Box>
      ) : (
        <Box className={style.colorNeutralGray1}>
          {state[showData].agent_user.name && (
            <Text variant="bodyBold.fontSize14">
              {state[showData].agent_user.name}
            </Text>
          )}
          {state[showData].agent_user.email && (
            <Box
              __css={{ marginTop: "4px" }}
              className={style.alignTextAndICon}
            >
              <Icon icon="icon-email" />
              <Text
                onClick={() =>
                  handleMailClick(state[showData].agent_user.email)
                }
                className={style.textHiden}
                variant="body.fontSize12"
              >
                {state[showData].agent_user.email}
              </Text>
            </Box>
          )}
          {state[showData].agent_user.phone && (
            <Box
              __css={{ marginTop: "4px" }}
              className={style.alignTextAndICon}
            >
              <Icon icon="icon-whatsapp" />
              <Text
                onClick={() =>
                  handleWhatsappClick(state[showData].agent_user.phone)
                }
                className={style.underline}
                variant="body.fontSize12"
              >
                {state[showData].agent_user.phone}
              </Text>
            </Box>
          )}
          {state[showData].agent_user.cellphone && (
            <Box
              __css={{ marginTop: "4px" }}
              className={style.alignTextAndICon}
            >
              <Icon icon="icon-celular" />
              <Text
                onClick={() =>
                  handleWhatsappClick(state[showData].agent_user.cellphone)
                }
                className={style.underline}
                variant="body.fontSize12"
              >
                {state[showData].agent_user.cellphone}
              </Text>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
